<template>
	<div class="packlist">
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>商品详情</span>
			<span></span>
		</div>
		<div style="height: 2rem;"></div>
		<div style="background-color: #fff;">
			<div class="swiper">
				<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" style="width: 100%; height: 100%;">
					<van-swipe-item v-for="(item,index) in msg.slider_image">
						<img :src="item" />
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>

		<div class="block">
			<div style="font-size: 0.9rem;">{{msg.title}}</div>
			<div style="color: red;">￥<span style="font-size: 1.25rem; color: red;">{{msg.price}}</span>/每月</div>
			<div v-if="msg.goods_work == 7">工期：7-10天</div>
			<div v-if="msg.goods_work == 15">工期：15-20天</div>
			<div v-if="msg.goods_work == 30">工期：30-40天</div>
		</div>
		<div class="block tresd">
			<div>
				<div>品牌&nbsp;&nbsp;&nbsp;<span>{{msg.goods_brand}}</span></div>
				<div>货号&nbsp;&nbsp;&nbsp;<span>{{msg.goods_number}}</span></div>
			</div>
			<div>
				<div>材质&nbsp;&nbsp;&nbsp;<span>{{msg.material}}</span></div>
				<div>产地&nbsp;&nbsp;&nbsp;<span>{{msg.place}}</span></div>
			</div>
			<div>
				<div>定制&nbsp;&nbsp;&nbsp;<span>{{msg.dz}}</span></div>
				<div>新旧&nbsp;&nbsp;&nbsp;<span>{{msg.newold}}</span></div>
			</div>
		</div>
		<div class="block">
			规格&nbsp;&nbsp;&nbsp;<span>{{msg.goods_spec_name}}</span>
		</div>
		<div class="block" style="padding: 0; width: 100%;">
			<div class="html" v-html="msg.content"></div>
		</div>
		<div style="height: 3rem;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				msg: '',
			}
		},
		created() {
			this.getseelists() // 获取浏览记录
		},
		methods: {
			// 获取商品信息
			getseelists() {
				this.$axios.post(baseUrl + '/mobile/whole/goodsinfo', {
					id: this.$route.query.id
				}).then((res) => {
					this.msg = res.data.data
					if (this.msg.dz == 0) {
						this.msg.dz = "是"
					} else {
						this.msg.dz = "否"
					}
				}).catch((err) => {
					console.log(err);
				});
			},

		}
	}
</script>

<style>
	.packlist .my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
	}

	.packlist .swiper {
		height: 15rem;
	}

	.packlist .swiper img {
		width: 100%;
		height: 100%;
	}

	.packlist .block {
		width: 90%;
		padding: 0.8rem 5%;
		background-color: #fff;
		font-size: 0.8rem;
		margin-top: 1rem;
		text-align: left;
	}

	.packlist .block>div {
		margin-bottom: 0.2rem;

	}

	.packlist .block span {
		color: #999;
	}

	.packlist .html {
		padding-top: 0.625rem;
		width: 96%;
		margin: auto;
	}

	.packlist .html p {
		display: block;
		margin-block-start: 0em;
		margin-block-end: 0em;
	}

	.packlist .html p img {
		display: block;
		width: 100%;
	}

	.packlist .block>div:last-child {
		margin-bottom: 0rem;
	}

	.packlist .tresd>div {
		display: flex;
	}

	.packlist .tresd>div>div {
		width: 45%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 5%;
	}
</style>



// WEBPACK FOOTER //
// src/components/packages/packlist.vue